import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from './service/auth.service';
import { UserService } from './service/user.service';
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['login.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent implements OnInit {

  userId: any;
  loading = false;
  error: any;

  constructor(public authService: AuthService, private userService: UserService) { }

  ngOnInit() {

    if (this.authService.loggedIn()) {
      this.userService.getUser().subscribe(user => {
        this.authService.redirect();
      });
    }
  }


  signin() {
    this.authService.login();
  }

}

